// Copyright (c) Docugami, Inc. All rights reserved.**/

import React from 'react';
import { CardTextContentProps, Content, ContentRoot } from "./CardTextContent";
import { getClassNames } from "./CardStyles";
import { RichTextSanitizingHtmlViewer } from "./RichTextSanitizingHtmlViewer";
import { useMemo } from "react";

export const CardRichTextContent = (props: CardTextContentProps) => {
    const classNames = useMemo(() => getClassNames(props.styles?.text), [props.styles?.text]);

    return (
        <ContentRoot background={props.background}>
            <Content
                className={classNames}
                maxLines={props.maxLines ?? 2}>
                <RichTextSanitizingHtmlViewer
                    html={props.text} />
            </Content>
        </ContentRoot>
    );
}
